import { Component, OnInit } from '@angular/core';
import { WalletService } from '../wallet.service';
import * as moment from 'moment';
import { CurrencyPipe, formatDate } from '@angular/common';
import { HttpParams } from '@angular/common/http';
import { JwtHelperService } from "@auth0/angular-jwt";
import { AdminViewService } from 'src/app/framework/services/admin-view.service';
const helper = new JwtHelperService();

@Component({
  selector: 'app-creidtlinereport',
  templateUrl: './creidtlinereport.component.html',
  styleUrls: ['./creidtlinereport.component.scss'],
  providers: [CurrencyPipe]
})
export class CreidtlinereportComponent implements OnInit {
  creditLineRoprtData: any;
  rowData: any;
  rowSelection: string;
  columnDefs: any;
  gridApi: any;
  gridColumnApi: any;
  searchValue: any;
  isButtonDisabled:boolean
  
  minFromDate;
  maxDate;
  minToDate;
  startDate;
  endDate;
  NumberofRecord: any;
  Summary: any;
  userRole:string = ''

  constructor(private walletService: WalletService, private currencyPipe: CurrencyPipe,private adminViewServices:AdminViewService) {
    let curdate = new Date().getFullYear().toString() +'-'+(new Date().getMonth() + 1).toString()+'-01';
    let endDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    let startDate = formatDate(curdate, 'yyyy-MM-dd', 'en');
    let params: any = new HttpParams().set('startDate', startDate).set('endDate', endDate )
    this.walletService.getCreditlineReport(params).subscribe(res => {
      if (res['httpcode'] == 200) {
        this.creditLineRoprtData = res['data'].CreditLine;
        this.NumberofRecord = res['data'].NumberofRecord;
        this.Summary = res['data'].Summary;
        this.setGrid(this.creditLineRoprtData);
        //;
      }
    }
    )
    const token: string = localStorage.getItem("accessToken");
    let decoded_token: any = helper.decodeToken(token);
    this.userRole = decoded_token.role;
  }
  exportData() {
    let header = this.columnDefs.map(columnDef => {
      let headerName = columnDef.headerName;
      return headerName;
      });
      let params: any = {
      fileName: 'Credit-line-Report.csv',
      //columnSeparator: ';',
      skipHeader: true,
      columnKeys: this.columnDefs.map(c => c.field || c.colId).filter(c => !!c)
      };
      params.customHeader = header.join(params.columnSeparator);
      params.processCellCallback = (cellParams) => {
      //  //creditDate lastFundTransferedDttm autoReloadedDate
     
      if(cellParams && cellParams.column.colId === '') {
        return ''; //apply your timestamp formatter 
      }else if(cellParams && cellParams.column.colId === 'creditDate' || 
      cellParams.column.colId === 'lastFundTransferedDttm' || cellParams.column.colId === 'autoReloadedDate') {
        return moment(cellParams.value).format('MM/DD/YYYY')
      }  else if(cellParams &&  
      cellParams.column.colId === 'creditTime'){
        return moment(cellParams.value).format('hh:mm:ss:a');
      }else return cellParams.value // no formatting
      }
      this.gridApi.exportDataAsCsv(params);
  }

  quickSearch(){
    this.gridApi.setQuickFilter(this.searchValue);
  } 
  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }


  ngOnInit(): void {
    
 this.adminViewServices.checkAdminVRole().subscribe((res) => {
      this.isButtonDisabled = res
    })
  }
  setGrid(data: any) {
    this.columnDefs = [
      {
        field: 'creditDate', headerName: 'Date', width: 180, cellRenderer: (data) => {
          return moment(data.value).format('MM/DD/YYYY') }},  
      { field: 'creditTime', headerName: 'Time', width: 180, cellRenderer: (data) => {
              return moment(data.value).format('hh:mm:ss:a') }},         
      { field: 'retailerName', headerName: 'Retailer', width:170 }, 
      { field: 'retailerAccountNum', headerName: 'Account #', width:150  },
      {
        field: 'creditlineAmount', headerName: 'Amount', width: 220, cellRenderer: (data) => {
          return this.currencyPipe.transform(data.value)} },
      { field: 'autoReloadThresholdStatus', headerName: 'Auto Reloaded Status', width: 240 },   
      { field: 'creditedBy', headerName: 'Transferred By', width:215  },
      { field: 'creatorRole', headerName: 'User Role', width:220  },
      { field: 'lastFundTransferedDttm', headerName: 'Last Transfer Date', width: 250, cellRenderer: (data) => {
          return moment(data.value).format('MM/DD/YYYY') }},
      { field: 'lastFundTransferedBy', headerName: 'Last Transfer By', width:250  },
      /*{ field: 'lastFundTransferedTo', headerName: 'Last Funds Transferred To', width: 250  },
      {
        field: 'autoReloadedDate', headerName: 'Auto Reloaded Date', width: 220, cellRenderer: (data) => {
          return data.value ?  moment(data.value).format('MM/DD/YYYY') : `<span class="text-center"> - </span>`
          }}*/
      ];
    this.rowData = data; 
    this.rowSelection = 'multi';
  }

  changeFromDate(e) {
    this.minToDate = e.value;
    this.startDate = formatDate(e.value, 'yyyy-MM-dd', 'en');
  }
  changeToDate(e) {
    this.endDate   = formatDate(e.value, 'yyyy-MM-dd', 'en');
    if (this.startDate != null && this.startDate != undefined) {
      let params: any = new HttpParams().set('startDate', this.startDate).set('endDate', this.endDate)
      this.walletService.getCreditlineReport(params).subscribe(res => {
        if (res['httpcode'] == 200) {
          this.creditLineRoprtData = res['data'].CreditLine;
          this.NumberofRecord = res['data'].NumberofRecord;
          this.Summary = res['data'].Summary;
          //this.setGrid(this.creditLineRoprtData);
          this.setRowData(this.creditLineRoprtData);
        }
      }
      )    
    }
  }
  setRowData(rowData: any) {
    this.rowData = rowData;
   }    
}